<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">{{(isEdit) ? 'Edit' : 'Add'}} News/Article</h3>
            </div>
            <v-stepper v-model="e1" light>
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1" editable>Newsfeed Details</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step  v-if="!isEdit" :complete="e1 > 2" step="2">Newsfeed Image</v-stepper-step>
                <v-stepper-step  v-if="isEdit"  :complete="e1 > 2" step="2" @click="validate" editable>Newsfeed Image</v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content class="v-form-body" step="1">
                  <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
                    <v-row>
                      <v-col cols="6">
                        <label class="form-control-label">
                          Title
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="newsFeed.title"
                          placeholder="Enter Title"
                          :rules="[(v) => !!v || 'Title is required!', (v) => v && !!v.trim() || 'Field cannot be blank']"
                          required
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <label class="form-control-label">
                          Category
                          <span class="red--text">*</span>
                        </label>
                        <treeselect
                          v-model="newsFeed.category"
                          :normalizer="normalizer"
                          placeholder="Select your Category"
                          :show-count="true"
                          search-nested
                          :options="categories"
                        />
                      </v-col>

                      <v-col cols="12">
                        <label class="form-control-label">
                          Summary
                          <span class="red--text">*</span>
                        </label>
                        <v-textarea
                          v-model="newsFeed.summary"
                          solo
                          label="Short description"
                          counter
                          maxlength="200"
                          auto-grow
                          :rules="[(v) => !!v || 'Summary is required!', (v) => v && !!v.trim() || 'Field cannot be blank']"
                          rows="3"
                        ></v-textarea>
                      </v-col>

                      <v-col cols="12">
                        <label class="form-control-label">
                          Description
                          <span class="red--text">*</span>
                        </label>
                        <quill-editor
                          v-model="newsFeed.description"
                          ref="myQuillEditor"
                          @input="error=[]"
                          :options="editorOption"
                        ></quill-editor>
                        <div v-if="error && error.length > 0" class="v-text-field__details pt-2 pl-2"><div class="v-messages theme--light error--text" role="alert"><div class="v-messages__wrapper"><div class="v-messages__message">{{ error[0] }}</div></div></div></div>
                      </v-col>

                      <v-col cols="6">
                        <label class="form-control-label">Youtube Video Link</label>
                        <v-text-field
                          v-model="newsFeed.videoUrl"
                          placeholder="Newsfeed video url"
                          :rules="validateUrl"
                          solo
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                      <v-menu
                        ref="menu1"
                        v-model="datepickerField"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                           <label class="form-control-label">Published Date</label>
                          <v-text-field
                            v-model="newsFeed.publishedDate"
                            label="Newsfeed publish date"
                            solo
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newsFeed.publishedDate"
                          no-title
                          @change="datepickerField = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                        <v-card-title class="pt-8 pr-0 justify-start text-no-wrap">
                          <h4>Published</h4>
                          <v-switch class="pl-4 pt-3 mt-0" v-model="status" flat:label="Yes" inset></v-switch>
                        </v-card-title>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                        <v-card-title class="pt-8 pr-0 justify-start text-no-wrap">
                          <h4>Comments Allow?</h4>
                          <v-switch class="pl-4 pt-3 mt-0" v-model="newsFeed.isCommentSetting" flat:label="Yes" inset></v-switch>
                        </v-card-title>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                        <v-card-title class="pt-8 pr-0 justify-start text-no-wrap">
                          <h4>Is recommended?</h4>
                          <v-switch class="pl-4 pt-3 mt-0" v-model="newsFeed.isRecommended" flat:label="Yes" inset></v-switch>
                        </v-card-title>
                      </v-col>

                      <v-col class="text-right" cols="12">
                        <v-btn color="#989898" class="mr-4 white--text" @click="cancel">Cancel</v-btn>
                        <v-btn
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="validate"
                        >Next</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content class="v-form-body" step="2">
                  <v-row>
                    <v-col :class="$vuetify.breakpoint.mdAndUp ? 'col-6' : 'col-12'" class="pa-5">
                      <v-card>
                        <v-card-title>
                          <span class="Subtitle 1">Upload Thumbnail Image</span>
                        </v-card-title>
                        <v-card-text>
                           <div class="upload-img-section">
                            <v-card flat class="pa-2">
                                <v-card-text class="text-center">
                                  <img v-if="thumbnailImageOption.croppedUrl === null" src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606300207502.png" class="thumbnail-img">
                                  <img v-if="thumbnailImageOption.croppedUrl !== null" :src="thumbnailImageOption.croppedUrl" class="thumbnail-img">
                                </v-card-text>
                                <v-card-actions class="justify-center">
                                <v-btn @click="$refs.thumbnailFileInput.click()" color="#344452" class="white--text px-1"> <v-icon class="mdi mdi-image"></v-icon> Browse </v-btn>
                                <input ref="thumbnailFileInput" type="file" style="display: none;" @change="onFileSelect($event,thumbnailImageOption)"/>
                                <v-btn v-if="thumbnailImageOption.croppedUrl!== null" color="gray" class="mx-2 delete-btn" @click="removeFile(thumbnailImageOption)" :loading="thumbnailImageOption.deleteLoading"><v-icon >mdi mdi-delete</v-icon> Delete</v-btn>
                                </v-card-actions>
                              </v-card>
                          </div>
                          <img-cropper
                          v-if="thumbnailImageOption.dialog"
                          :imageObject="thumbnailImageOption"
                          :moduleId="newsFeedId"
                          :media="thumbnails"
                          @updateMedia="updateMedia"
                          ></img-cropper> 
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col :class="$vuetify.breakpoint.mdAndUp ? 'col-6' : 'col-12'" class="pa-5">
                      <v-card>
                        <v-card-title>
                          <span class="Subtitle 1">Upload Banner Image</span>
                        </v-card-title>
                        <v-card-text>
                          <div class="upload-img-section">
                            <v-card flat class="pa-2">
                                <v-card-text class="text-center">
                                  <img v-if="bannerImageOption.croppedUrl === null" src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606300207502.png" class="banner-img">
                                  <img v-if="bannerImageOption.croppedUrl !== null" :src="bannerImageOption.croppedUrl" class="banner-img">
                                </v-card-text>
                                <v-card-actions class="justify-center">
                                <v-btn @click="$refs.bannerFileInput.click()" color="#344452" class="white--text px-1"> <v-icon class="mdi mdi-image"></v-icon> Browse </v-btn>
                                <input ref="bannerFileInput" type="file" style="display: none;" @change="onFileSelect($event,bannerImageOption)"/>
                                <v-btn v-if="bannerImageOption.croppedUrl!== null" color="gray"  class="mx-2 delete-btn" @click="removeFile(bannerImageOption)" :loading="bannerImageOption.deleteLoading"><v-icon>mdi mdi-delete</v-icon> Delete</v-btn>
                                </v-card-actions>
                              </v-card>
                          </div>
                          <img-cropper
                          v-if="bannerImageOption.dialog===true"
                          :imageObject="bannerImageOption"
                          :moduleId="newsFeedId"
                          :media="banners"
                          @updateMedia="updateMedia"
                          ></img-cropper>  
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <document-upload
                      :documents="documents"
                      moduleName="newsFeed"
                      :moduleId="newsFeedId"
                      v-if="e1 == 2"
                    ></document-upload>
                  </v-row>
                  <v-col class="text-right" cols="12">
                    <v-btn color="#989898" class="mr-4 white--text" @click="cancel">Cancel</v-btn>
                    <v-btn
                      :disabled="!valid"
                      color="#344452"
                      class="white--text"
                      :loading="loading"
                      @click="save"
                    >{{(isEdit) ? 'Update' : 'Save'}}</v-btn>
                  </v-col>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import { NewsfeedService, NewscategoryService, MediaService } from "@/services";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import { MEDIATYPE_THUMBNAIL, MEDIATYPE_BANNER,THUMBNAIL_WIDTH,THUMBNAIL_HEIGHT,BANNER_WIDTH,BANNER_HEIGHT } from "@/constants";
import { ImageValidateMixin } from "@/mixins";
import moment from "moment";

export default {
  name: "AddNewsFeed",
  components: {
    CommonSection,
    Treeselect,
    quillEditor,
    documentUpload: () => import("@/components/DocumentUpload"),
    ImgCropper: () => import("./components/ImgCropperModel"),
  },
  mixins: [ImageValidateMixin],
  data() {
    return {
      e1: 1,
      loading: false,
      open: ["public"],
      editorOption: {
        theme: "snow",
      },
      valid: true,
      categories: [],
      error : [],
      newsFeedId: null,
      status: false,
      media: [],
      newsFeed: {
        title: null,
        category: null,
        summary: null,
        description: null,
        status: false,
        videoUrl: null,
        publishedDate:null,
        isCommentSetting:true,
        isRecommended:false
      },
      datepickerField:false,
      validateUrl: [
        (v) =>
          !v ||
          /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/.test(
            v
          ) ||
          "Your url link is not valid.",
      ],
      thumbnailImageOption:{
        image: null,
        croppedUrl: null,
        croppedFile: null,
        loading:false,
        originalFile:null,
        width:THUMBNAIL_WIDTH,
        height:THUMBNAIL_HEIGHT,
        mediaType:MEDIATYPE_THUMBNAIL,
        dialog:false,
        deleteLoading:false
      },
      bannerImageOption:{
        image: null,
        croppedUrl: null,
        croppedFile: null,
        loading:false,
        originalFile:null,
        width:BANNER_WIDTH,
        height:BANNER_HEIGHT,
        mediaType:MEDIATYPE_BANNER,
        dialog:false,
        deleteLoading:false
      },
      isEdit : false
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    documents() {
      if (this.media && this.media.length > 0) {
        return this.media.filter((media) => media.mediaType == "doc");
      } else {
        return [];
      }
    },
    banners(){
      if (this.media && this.media.length > 0) {
        return this.media.filter((media) => media.imageType == "BANNER");
      } else {
        return [];
      }
    },
    thumbnails(){
      if (this.media && this.media.length > 0) {
        return this.media.filter((media) => media.imageType == "THUMBNAIL");
      } else {
        return [];
      }
    }
  },
  async mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      const categoryList = await NewscategoryService.getCategoryList();
      this.categories = categoryList.data;
      if (this.$route.params.id !== 'create') {
        await this.newsFeedUpdate();
        await this.uploadedImage();
        await this.uploadedBannerImage();
        this.isEdit = true;
      }
    },
    isEmpty () {
      return this.editor.getText().trim().length === 0
    },
    async newsFeedUpdate() {
      const newsFeed = await NewsfeedService.getNewsFeed(this.$route.params.id);
      this.newsFeed.title = newsFeed.data.data[0].title;
      this.newsFeed.category = newsFeed.data.data[0].category;
      this.newsFeed.summary = newsFeed.data.data[0].summary;
      this.newsFeed.description = newsFeed.data.data[0].description;
      this.newsFeed.videoUrl = newsFeed.data.data[0].videoUrl;
      this.media = newsFeed.data.data[0].media;
      this.status =
        newsFeed.data.data[0].status && newsFeed.data.data[0].status === 1
          ? true
          : false;
      this.fromWebsite = newsFeed.data.data[0].fromWebsite;
      this.newsFeed.publishedDate = (newsFeed.data.data[0].publishedDate) ? moment(newsFeed.data.data[0].publishedDate).format("YYYY-MM-DD") : null;
      this.newsFeed.isCommentSetting = newsFeed.data.data[0].isCommentSetting;
      this.newsFeed.isRecommended = newsFeed.data.data[0].isRecommended;
    },
    async newsfeedListData() {
      const newsDetails = await NewsfeedService.getNewsFeed(this.newsFeedId);
      this.media = newsDetails.data.data[0].media;
    },
    uploadedImage() {
      this.$set(this.thumbnailImageOption,'croppedUrl',null)
      if (this.media && this.media.length > 0) {
        this.media.filter((media) => {
          if (media.mediaType == "image" && media.imageType == "THUMBNAIL") {
            var file = {
              size: media.size,
              name: media.name,
              type: media.type,
               imageType: media.imageType
            };
            this.thumbnailImageOption.croppedFile = file;
            let imageUrl = (media.thumbnailUrl) ? media.thumbnailUrl : media.url;
            this.$set(this.thumbnailImageOption,'croppedUrl',imageUrl)
          }
        });
      }
    },
    uploadedBannerImage() {
      this.$set(this.bannerImageOption,'croppedUrl',null)
      if (this.media && this.media.length > 0) {
        this.media.filter((media) => {
          if (media.mediaType == "image" && media.imageType == "BANNER") {
            var file = {
              size: media.size,
              name: media.name,
              type: media.type,
              imageType: media.imageType
            };
            this.bannerImageOption.croppedFile = file;
            let imageUrl = (media.bannerUrl) ? media.bannerUrl : media.url;
            this.$set(this.bannerImageOption,'croppedUrl',imageUrl)
          }
        });
      }
    },
    async removeFile(imageOption) {
      imageOption.deleteLoading = true;
      await this.deletePicture(imageOption.croppedFile);
      if(imageOption.mediaType== "THUMBNAIL"){
        await this.uploadedImage();
      }
      if(imageOption.mediaType== "BANNER"){
        await this.uploadedBannerImage();
      }
      imageOption.deleteLoading = false;
    },
    async deletePicture(file) {
      try {
        if (file) {
          let mediaId = this.media.filter((media) => {
            if (media.mediaType == "image" && media.name == file.name) {
              return media._id;
            }
          });
          if (mediaId.length > 0) {
            const response = await MediaService.deleteMedia({
              id: mediaId[0]._id,
              body: {
                moduleType: "newsFeed",
                moduleId: this.newsFeedId,
              },
            });
            await this.newsfeedListData();
            if (response) {
              this.$store.dispatch(
                "user/setSnack",
                "Newsfeed image deleted successfully!"
              );
              this.$store.dispatch("user/setType", "info");
            }
          }
        }
      } catch (error) {
        this.$store.dispatch("user/setSnack", error);
        this.$store.dispatch("user/setType", "error");
      }
    },
    cancel() {
      this.$router.push("/news-feed");
    },
    async validate() {
      const value = this.isEmpty();
      if (this.$refs.form.validate() && !value) {
        this.loading = true;
        this.newsFeed.status = this.status ? 1 : 3;
        try {
          let response;
          if (this.$route.params.id !== 'create') {
            response = await NewsfeedService.updateNewsFeed({
              id: this.$route.params.id,
              object: this.newsFeed,
            });
          } else {
            response = await NewsfeedService.createNewsFeed(this.newsFeed);
          }
          this.loading = false;
          if (response) {
            this.e1 = 2;
            this.newsFeedId = response.data.id;
            this.$store.dispatch(
              "user/setSnack",
              `Newsfeed ${(this.isEdit) ? 'updated' : 'added'} successfully!`
            );
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }else if(value) {
        this.error.push('Description is required!')
      }
    },
    async save() {
      const value = this.isEmpty();
      if (this.$refs.form.validate() && !value) {
        this.loading = true;
        this.newsFeed.status = this.status ? 1 : 3;
        try {
          this.loading = false;
          this.$router.push("/news-feed");
          this.$store.dispatch("user/setSnack", `Newsfeed ${(this.isEdit) ? 'updated' : 'added'} successfully!`);
          this.$store.dispatch("user/setType", "info");
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }else if(value) {
        this.error.push('Description is required!')
      }
    },
    normalizer(node) {
      return {
        id: node._id,
        label: node.name,
        children: node.childs,
      };
    },
    onFileSelect(e,imageDataOption) {
      const file = e.target.files[0];
      if(!file || file.type.indexOf('image/') !== 0){
        this.$store.dispatch(
          "user/setSnack",
          "Invalid File. Please upload a valid Image file"
        );
        this.$store.dispatch("user/setType", "error");
        return;
      }
      var sizeInBytes = file.size;
      var fileSizeInMB = (sizeInBytes / (1024*1024)).toFixed(2);
      if(fileSizeInMB > 5){
        this.$store.dispatch(
          "user/setSnack",
          "You can upload file with maximum 5MB size."
        );
        this.$store.dispatch("user/setType", "error");
        return;
      } 
      if (typeof FileReader === 'function') {
          let reader = new FileReader();
          reader.onload = evt => {
            let img = new Image();
            img.onload = () => {
            if (img.width < imageDataOption.width || img.height < imageDataOption.height) {
                  this.$store.dispatch(
                      "user/setSnack",
                      "Invalid dimensions. Please upload a image of "+imageDataOption.width+"*"+imageDataOption.height+"px (minimum)."
                    );
                    this.$store.dispatch("user/setType", "error");
                }
                else{
                  imageDataOption.originalFile = file;
                  imageDataOption.dialog = true
                  imageDataOption.image = evt.target.result
                }
            }
            img.src = evt.target.result;
          }
          reader.readAsDataURL(file);
        } else {
          this.$store.dispatch(
            "user/setSnack",
            "Sorry, FileReader API not supported"
          );
          this.$store.dispatch("user/setType", "error");
      }
    },
    async updateMedia(mediaType){
      await this.newsfeedListData();
      if(mediaType== "THUMBNAIL"){
        await this.uploadedImage();
      }
      if(mediaType== "BANNER"){
        await this.uploadedBannerImage();
      }
    }
  },
};
</script>

<style scoped>
.main-content .navbar-top {
  display: none !important;
}
.thumbnail-img{
  height: 200px;
}
.banner-img{
  width: 300px;
  height: 200px;
}
.upload-img-section{
    border: 3px solid #D6E0EF !important;
    border-style: dashed !important;
    border-radius: 6px !important;
}
.delete-btn{
  color: #344452 !important;
}
</style>